import Navigo from "navigo";
import { bindRoutes } from "./routes";

// A thin wrapper about the Navigo router instance.
export class OnlineAppRouter {

    constructor(basePath, onlineApp) {
        this.name = 'OnlineApp Router';
        this.basePath = basePath;
        this.onlineApp = onlineApp;
        this.router = new Navigo(this.basePath);
        this.routes = bindRoutes(onlineApp);
        this.registerRoutes();
    }

    resolve(url) {
        console.groupCollapsed(`[${ this.name }] resolve: ${url}`);
        this.router.resolve(url);
        console.groupEnd();
    }

    navigate(url, options = {}) {
        console.groupCollapsed(`[${ this.name }] navigate: ${url}`, options);
        this.router.navigate(url, options);
        console.groupEnd();
    }

    navigateByName(routeName, routeData, options = {}) {
        console.groupCollapsed(`[${ this.name }] navigate by name: ${routeName}`, routeData, options);
        this.router.navigateByName(routeName, routeData, options);
        console.groupEnd();
    }

    match(path) {
        console.groupCollapsed(`[${ this.name }] match: ${path}`);
        let match = this.router.match(path) ?? [];
        console.log(match);
        console.groupEnd();
        return match;
    }

    generate(routeName, routeData) {
        console.groupCollapsed(`[${ this.name }] generate: ${routeName}`, routeData);
        const generatedPath = this.router.generate(routeName, routeData);
        console.groupEnd();
        return generatedPath;
    }

    navigateToSubpage(subpage, options = {}) {
        this.navigateByName('subpage', { subpage_id: subpage.slug }, options);
    }

    navigateToFilter(mapFilter, options = {}) {
        this.navigateByName('filter', { filter_id: mapFilter.slug }, options);
    }

    navigateToFilterExperience(mapFilter, experience, options = {}) {
        this.navigateByName(
            'filterExperience',
            { filter_id: mapFilter.slug, experience_id: experience.slug },
            options
        );
    }

    registerRoutes() {
        this.router.on(this.routes);
    }
}